var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgEnvelopeClosedFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? _titleId ? _titleId : "title-" + titleId : undefined;
    return React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.592 7.63a.224.224 0 0 0-.342.19v9.661a.5.5 0 0 0 .854.354l5.487-5.487a.5.5 0 0 0-.077-.77L2.592 7.63Zm1.571 11.266a.5.5 0 0 0 .354.854H19.48a.5.5 0 0 0 .354-.854l-5.842-5.841a.5.5 0 0 0-.63-.063l-.948.632a.75.75 0 0 1-.832 0l-.947-.632a.5.5 0 0 0-.631.063l-5.842 5.841Zm16.733-1.06a.5.5 0 0 0 .854-.353V7.821a.225.225 0 0 0-.344-.19l-5.922 3.947a.5.5 0 0 0-.076.77l5.488 5.489Zm.414-11.915c.213-.133.3-.425.087-.558A.747.747 0 0 0 21 5.25H3a.747.747 0 0 0-.398.114c-.213.134-.126.425.087.558l.708.442a.8.8 0 0 1 .018.012l8.307 5.538a.5.5 0 0 0 .554 0l8.307-5.538a.827.827 0 0 1 .019-.012l.708-.443Z", fill: "currentColor" }));
});
export default SvgEnvelopeClosedFill;
